module.exports = __webpack_public_path__ + "assets/920b215298f5effe86b29b1125418590.png";